<h1 mat-dialog-title>Income Verification Request</h1>

<div mat-dialog-content>
  <div>
    <form [formGroup]="formtaxrequest" autocomplete="off" style="margin-top: 6px; color: #212529;">

      <span> {{this.yearquestion}} </span>

      <mat-radio-group required id="householdStatus" name="householdStatus" formControlName="householdStatus" required (change)="onChangeEvent($event)"
        class="retrofit-task-radio-group" >
        <mat-radio-button hidden></mat-radio-button>
        <mat-radio-button value="Single"><span style="white-space:pre-wrap">Single</span></mat-radio-button>
        <mat-radio-button value="Qualifying Widow(er) with Dependent Child"><span style="white-space:pre-wrap">Qualifying Widow(er) with Dependent Child</span></mat-radio-button>
        <mat-radio-button value="Head of Household"><span style="white-space:pre-wrap">Head of Household</span></mat-radio-button>
        <mat-radio-button value="Married Filing Separately"><span style="white-space:pre-wrap">Married Filing Separately</span></mat-radio-button>
        <mat-radio-button value="Married Filing Jointly"><span style="white-space:pre-wrap">Married Filing Jointly</span></mat-radio-button>
      </mat-radio-group>

      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>First Name</mat-label>
        <input matInput autocomplete="off" placeholder="First Name shown on tax return" minlength="1" maxlength="12" id="nameFirst" name="nameFirst" formControlName="nameFirst"
          required="true" pattern="^[a-zA-Z0-9.',\s\'\-]*$"/>
          @if (formtaxrequest.get('nameFirst').invalid) {
            <mat-error>
              This field is required. No special characters allowed (e.g., &#64;#!%ñ).
            </mat-error>
          }
          @if (formtaxrequest.get('nameFirst').value && formtaxrequest.get('nameFirst').value.length >= 12) {
            <mat-hint>
              12 character limit
            </mat-hint>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Middle Initial</mat-label>
          <input matInput autocomplete="off" placeholder="Middle initial shown on tax return" maxlength="1" id="nameInitial" name="nameInitial" formControlName="nameInitial"
            required="false" pattern="^[a-zA-Z]*$" />
            @if (formtaxrequest.get('nameInitial').invalid) {
              <mat-error>
                No special characters allowed (e.g., &#64;#!%ñ).
              </mat-error>
            }
            @if (formtaxrequest.get('nameInitial').value && formtaxrequest.get('nameInitial').value.length >= 1) {
              <mat-hint>
                1 character limit
              </mat-hint>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Last Name</mat-label>
            <input matInput autocomplete="off" placeholder="Last Name shown on tax return" minlength="1" maxlength="22" id="nameLast" name="nameLast" formControlName="nameLast"
              required="true" pattern="^[a-zA-Z0-9.',\s\'\-]*$" />
              @if (formtaxrequest.get('nameLast').invalid) {
                <mat-error>
                  This field is required. No special characters allowed (e.g., &#64;#!%ñ).
                </mat-error>
              }
              @if (formtaxrequest.get('nameLast').value && formtaxrequest.get('nameLast').value.length >= 22) {
                <mat-hint>
                  22 character limit
                </mat-hint>
              }
            </mat-form-field>
            @if (data.isBorrowerAssisted) {
              <mat-form-field
                appearance="outline"
                style="width: 100%;">
                <mat-label>SSN/ITIN</mat-label>
                <input matInput autocomplete="off"
                  [hiddenInput]="true"
                  mask="XXX-XX-0000"
                  placeholder="Social Security Number or ITIN"
                  id="nameSSN"
                  name="nameSSN"
                  (keyup)="onChangeSsn($event, 'nameSSN')"
                  formControlName="nameSSN">
                  @if (formtaxrequest.get('nameSSN')?.hasError('required')
                    && (formtaxrequest.get('nameSSN')?.touched || submitted)) {
                    <mat-error
                      >
                      SSN/ITIN is required
                    </mat-error>
                  }
                  <!-- Show SAME-SSN message separately -->
                  <!-- If you set the error on the FORM (recommended, see TS below): -->
                  @if (formtaxrequest.hasError('ssnSame')
                    && (formtaxrequest.get('nameSSN')?.touched || submitted)) {
                    <mat-error
                      >
                      SSN/ITIN cannot be the same.
                    </mat-error>
                  }
                  @if (formtaxrequest.get('nameSSN').value && formtaxrequest.get('nameSSN').value.length > 11) {
                    <mat-hint>
                      9 character limit
                    </mat-hint>
                  }
                  @if (readOnlySsnLast4) {
                    <mat-hint>
                      Enter new value to update SSN/ITIN
                    </mat-hint>
                  }
                </mat-form-field>
              }
              @if (data.isMarried) {
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Spouse First Name</mat-label>
                  <input matInput autocomplete="off" placeholder="Spouse First Name shown on tax return" minlength="1" maxlength="12" id="nameFirstSpouse" name="nameFirstSpouse" formControlName="nameFirstSpouse"
                    required="true" pattern="^[a-zA-Z0-9.',\s\'\-]*$" />
                    @if (formtaxrequest.get('nameFirstSpouse').invalid) {
                      <mat-error>
                        This field is required. No special characters allowed (e.g., &#64;#!%ñ).
                      </mat-error>
                    }
                    @if (formtaxrequest.get('nameFirstSpouse').value && formtaxrequest.get('nameFirstSpouse').value.length >= 12) {
                      <mat-hint>
                        12 character limit
                      </mat-hint>
                    }
                  </mat-form-field>
                }

                @if (data.isMarried) {
                  <mat-form-field appearance="outline" style="width: 100%;">
                    <mat-label>Spouse Middle Initial</mat-label>
                    <input matInput autocomplete="off" placeholder="Spouse Middle initial shown on tax return" maxlength="1" id="nameInitialSpouse" name="nameInitialSpouse" formControlName="nameInitialSpouse"
                      required="false" pattern="^[a-zA-Z]*$" />
                      @if (formtaxrequest.get('nameInitialSpouse').invalid) {
                        <mat-error>
                          No special characters allowed (e.g., &#64;#!%ñ).
                        </mat-error>
                      }
                      @if (formtaxrequest.get('nameInitialSpouse').value && formtaxrequest.get('nameInitialSpouse').value.length >= 1) {
                        <mat-hint>
                          1 character limit
                        </mat-hint>
                      }
                    </mat-form-field>
                  }

                  @if (data.isMarried) {
                    <mat-form-field appearance="outline" style="width: 100%;">
                      <mat-label>Spouse Last Name</mat-label>
                      <input matInput autocomplete="off" placeholder="Spouse Last Name shown on tax return" minlength="1" maxlength="22" id="nameLastSpouse" name="nameLastSpouse" formControlName="nameLastSpouse"
                        required="true" pattern="^[a-zA-Z0-9.',\s\'\-]*$" />
                        @if (formtaxrequest.get('nameLastSpouse').invalid) {
                          <mat-error>
                            This field is required. No special characters allowed (e.g., &#64;#!%ñ).
                          </mat-error>
                        }
                        @if (formtaxrequest.get('nameLastSpouse').value && formtaxrequest.get('nameLastSpouse').value.length >= 22) {
                          <mat-hint>
                            22 character limit
                          </mat-hint>
                        }
                      </mat-form-field>
                    }
                    @if (data.isMarried && data.isBorrowerAssisted) {
                      <mat-form-field
                        appearance="outline"
                        style="width: 100%;" >
                        <mat-label>Spouse SSN/ITIN</mat-label>
                        <input matInput autocomplete="off"
                          [hiddenInput]="true"
                          mask="XXX-XX-0000"
                          placeholder="Social Security Number or ITIN"
                          id="nameSSNSpouse"
                          name="nameSSNSpouse"
                          (keyup)="onChangeSsn($event, 'nameSSNSpouse')"
                          formControlName="nameSSNSpouse">
                          <!-- ONLY show when it's actually 'required' -->
                          @if (formtaxrequest.get('nameSSNSpouse')?.hasError('required')
                            && (formtaxrequest.get('nameSSNSpouse')?.touched || submitted)) {
                            <mat-error
                              >
                              Spouse SSN/ITIN is required
                            </mat-error>
                          }
                          <!-- Show SAME-SSN message separately -->
                          <!-- If you set the error on the FORM (recommended, see TS below): -->
                          @if (formtaxrequest.hasError('ssnSame')
                            && (formtaxrequest.get('nameSSNSpouse')?.touched || submitted)) {
                            <mat-error
                              >
                              SSN/ITIN cannot be the same.
                            </mat-error>
                          }
                          @if (formtaxrequest.get('nameSSNSpouse').value && formtaxrequest.get('nameSSNSpouse').value.length > 11) {
                            <mat-hint>
                              9 character limit
                            </mat-hint>
                          }
                          @if (readOnlySsnLast4) {
                            <mat-hint>
                              Enter new value to update Spouse SSN/ITIN
                            </mat-hint>
                          }
                        </mat-form-field>
                      }
                      @if (data.isBorrowerAssisted) {
                        <mat-form-field appearance="outline" style="width: 100%;">
                          <mat-label>Email Address</mat-label>
                          <input
                            matInput
                            id="email"
                            name="email"
                            formControlName="email"
                            placeholder="Enter email address"
                            type="text"
                            required trim="blur">
                            @if (formtaxrequest.get('email')?.hasError('required')) {
                              <mat-error>Email Address is required</mat-error>
                            }
                            @if (formtaxrequest.get('email')?.hasError('pattern')) {
                              <mat-error>Invalid Email Address</mat-error>
                            }
                            @if (formtaxrequest.get('email')?.hasError('maxLength')) {
                              <mat-error>You have exceeded the maximum number of 100 characters.</mat-error>
                            }
                          </mat-form-field>
                        }


                        <span class="retrofit-form-text">
                          <p [innerHTML]="data.taxrequestmsg" style="overflow-wrap: anywhere;"></p>
                        </span>
                        <div mat-dialog-actions style="margin-top: 18px !important; float: right !important;">
                          <button mat-button (click)="onClickCancel()">
                            CANCEL
                          </button>
                          <button mat-flat-button (click)="onSave()" [disabled]="(formtaxrequest.pristine || formtaxrequest.invalid)" color="primary">
                            {{ data.isBorrowerAssisted ? 'SAVE & SUBMIT' : 'SAVE' }}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
